import { render, staticRenderFns } from "./ArticleCategoryTable.vue?vue&type=template&id=30946f69"
import script from "./ArticleCategoryTable.vue?vue&type=script&lang=ts"
export * from "./ArticleCategoryTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports